import React from 'react'
import {EditGuesser} from '@api-platform/admin'
import {TextInput, BooleanInput} from 'react-admin';
import {useTranslation} from "react-i18next";
import SidSelect from "./SidSelect";

function Edit(props) {
    const {t} = useTranslation()

    return (
        <EditGuesser {...props}>
            <TextInput source="name" label={t('common.name')}/>
            <SidSelect/>
            <BooleanInput source="isData" label={t('admin.isData')}/>
        </EditGuesser>
    )
}

export default Edit
